/**
 * InputRadios
 */

import { RadioButtonGroupProps, useFormContext, useWatch } from 'react-hook-form-mui';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { ReactNode } from 'react';
import { FieldLabel, FieldLabelBorder } from '../FieldLabel';
import { styled } from '@mui/material/styles';
import { useDefaultProps } from '../useDefaultProps';

const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  '& .MuiFormControlLabel-label ': {
    fontSize: '16px',

    [theme.breakpoints.down(1520)]: {
      fontSize: '14px',
    },
  },
  '& .MuiButtonBase-root.MuiRadio-root': {
    [theme.breakpoints.down(1520)]: {
      padding: '5px',
    },
  },
}));

export const RhfMuiRadioGroup: React.FC<
  RadioButtonGroupProps<any> & {
    children?: ReactNode; // this props is only use for NoticeUCT for now
    labelProps?: {
      border?: FieldLabelBorder;
    };
  }
> = (props) => {
  const { label, isReadOnly, options, name, ...rest } = { ...props, ...useDefaultProps(props) };

  const value = useWatch({ name });
  const { setValue } = useFormContext();

  const handleChange = (e) => {
    // questionId: question.answerOptions[].id
    setValue(name, e.target.value);
  };

  return (
    <FieldLabel label={label} border={rest?.labelProps?.border}>
      {!isReadOnly && (
        <StyledRadioGroup value={value} name={name} row onChange={handleChange}>
          {options.map((option) => (
            <FormControlLabel key={option.id} value={option.id} disabled={option.disabled} control={<Radio {...rest} />} label={option.label} />
          ))}
        </StyledRadioGroup>
      )}
      {isReadOnly && <div className='text-14 xl:text-base'>{options.find((o) => o.id === value)?.label}</div>}

      {rest?.children}
    </FieldLabel>
  );
};
